import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/instagram': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.1 141c63.6 0 114.9 51.3 114.9 114.9 0 63.6-51.3 114.9-114.9 114.9-63.6 0-114.9-51.3-114.9-114.9 0-63.6 51.3-114.9 114.9-114.9zM224.1 330.6c41.1 0 74.7-33.5 74.7-74.7 0-41.2-33.5-74.7-74.7-74.7-41.2 0-74.7 33.5-74.7 74.7 0 41.2 33.6 74.7 74.7 74.7zM370.5 136.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zM446.6 163.5c2.1 37 2.1 147.8 0 184.8-1.8 35.9-10 67.7-36.2 93.9-26.2 26.3-58 34.5-93.9 36.2-37 2.1-147.9 2.1-184.9 0-35.9-1.8-67.6-10-93.9-36.2s-34.5-58-36.2-93.9c-2.1-37-2.1-147.9 0-184.9 1.8-35.9 9.9-67.7 36.2-93.9s58.1-34.4 93.9-36.1c37-2.1 147.9-2.1 184.9 0 35.9 1.8 67.7 10 93.9 36.2 26.3 26.2 34.5 58 36.2 93.9zM398.8 388c11.7-29.4 9-99.5 9-132.1 0-32.6 2.7-102.6-9-132.1-7.9-19.7-23-34.8-42.6-42.6-29.4-11.6-99.5-9-132.1-9-32.6 0-102.6-2.7-132.1 9-19.7 7.9-34.8 23-42.6 42.6-11.6 29.4-9 99.5-9 132.1 0 32.6-2.7 102.6 9 132.1 7.9 19.7 23 34.8 42.6 42.6 29.4 11.6 99.5 9 132.1 9 32.6 0 102.6 2.7 132.1-9 19.7-7.9 34.8-23 42.6-42.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/instagram.js
// module id = 886
// module chunks = 0